module.exports = __webpack_public_path__ + "static/media/icon.7c77a1ea.png";